import isUndefined from 'lodash/isUndefined';

import { Availability } from '@dreryk/egabinet-appointment-frontend-api';
import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../translations';

type AvailabilityUpdatePanelLoaderProps = {
   readonly children: JSX.Element;
   readonly availabilityLoading: boolean;
   readonly availability: Availability | undefined;
   readonly healthcareLocationsLoading: boolean;
   readonly healthcareLocations: HealthcareProviderLocation[] | undefined;
};

export const AvailabilityUpdatePanelLoader = (props: AvailabilityUpdatePanelLoaderProps): JSX.Element => {
   if (props.availabilityLoading || props.healthcareLocationsLoading) {
      return <LoaderSpinner />;
   }

   if (isUndefined(props.availability) || isUndefined(props.healthcareLocations)) {
      return (
         <Message
            testId={'availabilityDataFetchError'}
            type={MessageType.NEGATIVE}
            label={personnelTranslationKeys.availability.update.form.errors.fetchData}
            displayIndicator
         />
      );
   }

   return props.children;
};
